import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateProfessionDto, UpdateProfessionDto } from '../dtos/profession/professionDto';

@Injectable({
  providedIn: 'root'
})
export class ProfessionService {

  private apiUrl = `${environment.apiUrl}/profession`;

  constructor(private http: HttpClient) {}

  getList(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`);
  }

  create(entity: CreateProfessionDto): Observable<any> {
    return this.http.post(`${this.apiUrl}`, entity);
  }

  update(id: number, entity: UpdateProfessionDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, entity);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
